// @ts-strict-ignore
import {EntryRowTypeHelpers} from 'common/query-builder/query-entry-section/row-types/types';
import {EntryPart, QueryFilterEntry, SelectorTypeDefinitions} from 'common/query-builder/query-entry-section/types';
import {isEventBasedBehavioralSegmentation} from 'common/query-builder/query-entry-section/row-types/behavior/utils';

// eslint-disable-next-line import/no-cycle
import {FilterEntryRow} from './index';
import {createFilter} from './utils';

export const helpers: EntryRowTypeHelpers<QueryFilterEntry> = {
  component: FilterEntryRow,
  getNewEntry: () => ({
    type: SelectorTypeDefinitions.Filter,
    filtersOperator: null,
    filters: [],
    event: null,
  }),
  isPlaceholder(row) {
    const filter = createFilter(row);

    if (
      isEventBasedBehavioralSegmentation(filter) &&
      (row.entry.event.behavior?.property?.value === null ||
        row.entry.event.behavior?.event?.value === null ||
        row.entry.event.behavior?.aggregationOperator === null)
    ) {
      return true;
    }

    return !filter.isValid();
  },
  isIntermediatePlaceholder(row) {
    const isPlaceholder = this.isPlaceholder(row);

    // allow placeholder when selecting the first list item filter
    if (row.sectionProps.listProperty && row.index === 0) {
      return true;
    }

    return isPlaceholder && !!row.entry.event;
  },
  getDefaultActiveEntryPart: (row) => {
    const filter = createFilter(row);

    if (filter.hasSelectedProperty()) {
      return EntryPart.FilterValue;
    }

    if (filter.behavior?.behaviorType === `$behavior_aggregation`) {
      return EntryPart.SubValue;
    }

    return EntryPart.Value;
  },
};
